<template>
  <div id="app">
    <!-- <router-view /> -->
     <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>
export default {
  name: 'language',
  data() {
    return {
    };
  },
  created() {
    document.title = process.env.VUE_APP_TITLE;
  }
}
</script>
<style lang="scss">

#app {
  
  box-sizing: border-box;
  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }
  /* end */
}
* {
  margin: 0;
  padding: 0;
}
</style>
